import { config } from 'config';

export function numberFormatReturn(number, digits, locale, { isTruncated = null } = {}) {
  let truncated = null;
  if (isTruncated) {
    const factor = 10 ** digits;
    truncated = Math.trunc(number * factor) / factor;
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: config.isoMoney,
    maximumFractionDigits: digits,
  }).format(isTruncated ? truncated : number);
}

export function formatNumber(number, fractionDigits = 0) {
  const numberString = number != null ? number?.toString() : 0.0;
  return numberFormatReturn(numberString, fractionDigits);
}

export function formatNumberTruncated(number, fractionDigits = 0) {
  const numberString = number != null ? number?.toString() : 0.0;
  return numberFormatReturn(numberString, fractionDigits, undefined, { isTruncated: true });
}

export function formatBankNumber(number) {
  const decimal = number?.slice(-2);
  const integer = number?.slice(0, -2);
  const value = `${integer}.${decimal}`;
  return formatNumber(value);
}
